export function getPageTitle (title: string) {
  return title + " - Minh Nguyen"
}